import React, { useCallback, useMemo } from "react"

import classNames from "classnames"
import Masonry from "react-masonry-component"

import { MediaQuery, useMediaQuery } from "../../../utils/hooks/mediaQuery"
import * as styles from "./MasonryGrid.module.scss"

const MasonryGrid = ({
  children,
  isLarge = false,
  isFull = false,
  className,
  horzontalOrder = true,
  numberColumns = 3,
}) => {
  const isTablet = useMediaQuery(MediaQuery.Tablet)

  const gutterWidth = useMemo(() => {
    if (isFull) {
      return 0
    }

    return isTablet ? 24 : 12
  }, [isTablet, isFull])

  const itemWidth = useMemo(() => {
    if (isLarge) {
      return isTablet ? "49.99%" : "100%"
    }

    if (numberColumns === 2) {
      return isTablet ? "49.99%" : "100%"
    } else return isTablet ? "32.99%" : "49.99%"
  }, [isTablet, isLarge, numberColumns])

  const onRef = useCallback((ref) => {
    if (ref) {
      window.addEventListener("tile-loaded", () => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            ref.masonry.layout()
          })
        })
      })
    }
  }, [])

  return (
    <div className={classNames(styles.masonryWrapper, className)}>
      <Masonry
        ref={onRef}
        options={{
          transitionDuration: 0,
          gutter: isFull ? 0 : gutterWidth,
          percentPosition: true,
          horizontalOrder: horzontalOrder,
          columnWidth: 1,
        }}
        className={classNames(className)}
        style={{
          // "--masonry-item-gutter": `${(gutterWidth * 2) / 3}px`,
          "--masonry-item-gutter": `${(gutterWidth * 2) / 3}px`,
          "--masonry-item-width": itemWidth,
        }}
        updateOnEachImageLoad
      >
        {children}
      </Masonry>
    </div>
  )
}

export { MasonryGrid }
